import { render, staticRenderFns } from "./TeamInfoPage.vue?vue&type=template&id=8485f652&"
import script from "./TeamInfoPage.vue?vue&type=script&lang=js&"
export * from "./TeamInfoPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports